import { jsx as _jsx } from "react/jsx-runtime";
import { InfoState } from '@gemini/ui';
const ErrorContent = ({ title, description, image, startButtonProps, endButtonProps, }) => {
    return (_jsx(InfoState, { title: title, description: description, image: image, startButtonProps: startButtonProps && {
            children: startButtonProps.label,
            onPress: startButtonProps.action,
        }, endButtonProps: endButtonProps && {
            children: endButtonProps.label,
            onPress: endButtonProps.action,
        } }));
};
export default ErrorContent;
